// extracted by mini-css-extract-plugin
export default {"Row":"DataTable_Row__wmyOs"};